import React from 'react';

class FormReceitas extends React.Component {
    render(){
        return(
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <h1 style={{marginTop:-100, marginBottom:20}}>Adicionar Receitas</h1>
                        <form>
                            <div class="form-group">
                                <label for="exampleFormControlInput1">Nome</label>
                                <input name="nome" value={this.props.nome} onChange={this.props.onChange} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Nome da Receita"></input>
                            </div>
                            <div class="form-group">
                                <label for="exampleFormControlInput1">Descrição</label>
                                <input name="descricao" value={this.props.descricao} onChange={this.props.onChange} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Breve descrição para a exposição"></input>
                            </div>
                            <div class="form-group">
                                <label for="exampleFormControlInput1">Link da imagem</label>
                                <input name="imagem_url" value={this.props.imagem_url} onChange={this.props.onChange} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Url da imagem"></input>
                            </div>
                            <div class="form-group">
                                <label for="exampleFormControlInput1">Quantidade de pessoas</label>
                                <input name="qtd_pessoas" value={this.props.qtd_pessoas} onChange={this.props.onChange} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Quantos servem a refeição"></input>
                            </div>
                            <div class="form-group">
                                <label for="exampleFormControlInput1">Calorias</label>
                                <input name="calorias" value={this.props.calorias} onChange={this.props.onChange} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Quantidade calorica da refeição (só numeros)"></input>
                            </div>
                            <div class="form-group">
                                <label for="exampleFormControlInput1">Tempo de preparo</label>
                                <input name="tempo" value={this.props.tempo} onChange={this.props.onChange} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Tempo que leva para ficar pronta a refeição (só minutos)"></input>
                            </div>
                            <div class="form-group">
                                <label for="exampleFormControlTextarea1">Ingredientes</label>
                                <textarea name="ingredientes" value={this.props.ingredientes} onChange={this.props.onChange} class="form-control" id="exampleFormControlTextarea1" placeholder="Insira os ingredientes com virgula sem pular linha" rows="3"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="exampleFormControlTextarea1">Modo de preparo</label>
                                <textarea name="como_fazer" value={this.props.como_fazer} onChange={this.props.onChange} class="form-control" id="exampleFormControlTextarea1" placeholder="Insira o modo de preparo detalhado" rows="3"></textarea>
                            </div>
                            <button onClick={this.props.onClick} type="submit" class="btn btn-primary">Enviar</button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default FormReceitas;